export enum ImageHandlerOutputFormat {
  JPG = "jpeg",
  PNG = "png",
}
